


































































































































































































import { Component, Vue, Prop, Watch, Ref } from "vue-property-decorator";
import DataDokter from "@/services/DataUtility";
import DataSpri from "@/services/DataSpri";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import { userModule } from "@/store/modules/user";
import { storeSpri } from "@/store/modules/spri";
import { appModule } from "@/store/modules/app";
import { isEmpty } from "lodash";
import { storePenunjang } from "@/store/modules/penunjang";
import SoapRanapStore from "@/store/modules/SoapRanapStore";
import {
  adaSoapRegister,
  mapSoapToSpri,
  pickSoapDokterTerakhir
} from "@/utils/spriFromSoap";
import moment from "moment";

@Component({
  components: {
    CardModalTtd
  },
  inject: { isReadOnly: { default: () => () => false } }
})
export default class CardInputSpri extends Vue {
  @Prop() readonly value!: boolean;
  @Prop() err!: object;
  // @Prop() sess_login!: object;
  @Prop() register!: string;
  @Prop() dataSoap: object;
  @Prop() dpjp: object;
  @Prop() instantCreate = false;

  @Ref() dateTimePicker: HTMLInputElement;

  isReadOnly!: () => boolean;
  get readOnly(): boolean {
    return this.isReadOnly();
  }

  dtSpri: object = {};
  sess_login = userModule.user;
  listDokter: object = {};
  tanggal: string | Date = new Date();
  keluhan_utama = "";
  riwayat_penyakit = "";
  pemeriksaan_fisik = "";
  pemeriksaan_penunjang = "";
  diagnosis = "";
  terapi = "";
  soap: object = {};
  modalTtd = false;
  expandInput = false;
  saving = false;

  timePickerProps = { format: "24hr", scrollable: true };
  datePickerProps = { locale: "id", max: moment().format("YYYY-MM-DD") };
  dateTimeFieldProps = {
    outlined: true,
    dense: true,
    "hide-details": "auto",
    class: "pb-2"
  };

  get soapCpptTerakhir() {
    return pickSoapDokterTerakhir(SoapRanapStore.soap, this.register);
  }

  get showGenerateBtn() {
    return !this.keluhan_utama && !!this.soapCpptTerakhir;
  }

  generateFromSoapCppt() {
    const soap = this.soapCpptTerakhir;
    if (!soap) return;

    const orderLab = this.orderLabItems.length
        ? `Lab: ${this.orderLabItems.join(", ")}`
        : null,
      orderRadiologi = this.orderRadiologiItems.length
        ? `Ro: ${this.orderRadiologiItems.join(", ")}`
        : null,
      pemPenunjang = [orderLab, orderRadiologi]
        .filter(item => item)
        .join("\r\n")
        .trim();

    const prefill = mapSoapToSpri(soap);

    this.dpjp = this.dokterDariSoap(soap);
    this.keluhan_utama = prefill.keluhan_utama;
    this.riwayat_penyakit = prefill.riwayat_penyakit;
    this.pemeriksaan_fisik = prefill.pemeriksaan_fisik;
    this.pemeriksaan_penunjang = pemPenunjang || "-";
    this.diagnosis = prefill.diagnosis;
    this.terapi = prefill.terapi;
  }

  private dokterDariSoap(soap) {
    const penulis = soap?.user?.id
      ? soap.user
      : { id: this.sess_login["id"], nama: this.sess_login["nama"] };

    const daftar = Array.isArray(this.listDokter) ? this.listDokter : [];
    const cocok = daftar.find(d => String(d.id) === String(penulis.id));

    return cocok || { id: penulis.id, nama: penulis.nama };
  }

  get orderLabItems() {
    return storePenunjang.listorderLab
      .filter(order => {
        return order.status > 0;
      })
      .map(order => {
        return order.items.map(item => item.name);
      });
  }

  get orderRadiologiItems() {
    return storePenunjang.listorderRadiologi
      .filter(order => {
        return order.status > 0;
      })
      .map(order => {
        return order.items.map(item => item.name);
      });
  }

  get dialog() {
    // console.log(this.value);

    return this.value;
  }
  set dialog(value) {
    this.$emit("input", value);
  }
  mounted() {
    this.dokterList();
    this.pastikanSoapCpptTermuat();
    // this.soap = this.dataSoap;
    // console.log("so", this.soap);
    // this.getSpri()

    // console.log('dtsoap ',this.getSoap())
  }
  @Watch("register")
  change(val) {
    this.register = val;
  }
  @Watch("dataSoap")
  changeSOAP(value) {
    // console.log("dtspri", value);
    // if (value == undefined) {
    this.soap = value;
    this.keluhan_utama = this.soap["keluhan_utama"];
    this.pemeriksaan_penunjang = this.soap["pemeriksaan_penunjang"];
    this.riwayat_penyakit = this.soap["s"];
    this.pemeriksaan_fisik = this.soap["o"];
    this.diagnosis = this.soap["a"];
    this.terapi = this.soap["p"];
    this.tanggal = this.soap["tanggal"]
      ? new Date(this.soap["tanggal"])
      : new Date();
    // } else

    if (value != null) {
      this.getSpri();
    }
    // console.log("watch mdal", this.soap)
  }

  @Watch("instantCreate")
  async changeInstantCreate(val) {
    if (val) {
      if (userModule.user.unit_id == "01" && isEmpty(this.dtSpri)) {
        await this.pastikanSoapCpptTermuat();
        this.generateFromSoapCppt();
      }

      // this.simpanSpri();
    }
  }

  private async pastikanSoapCpptTermuat() {
    if (!this.register) return;
    if (adaSoapRegister(SoapRanapStore.soap, this.register)) return;

    await SoapRanapStore.getByRegister(this.register);
  }

  passTtd(value) {
    this.$emit("passTtd", value);
    // this.modalTtd = false;
  }

  dokterList() {
    const dktr = DataDokter.getListDokter();
    dktr.then(dktr => {
      this.listDokter = dktr;
    });
  }
  getSpri() {
    // appModule.setLoading(true);

    const dt = DataSpri.getDataSpri(this.register);
    dt.then(dt => {
      // appModule.setLoading(false);
      this.dtSpri = dt;
    });
  }
  simpanSpri() {
    if (this.readOnly) return;
    // console.log("sv", this.dtSpri);
    if (!this.saving) {
      this.saving = true;
      // appModule.setLoading(true);
      const tgl = moment(this.tanggal).format("YYYY-MM-DD HH:mm:ss");

      if (this.dtSpri["status"] == 1) {
        const dt = DataSpri.editDataSpri(
          this.dtSpri["data"][0]["id"],
          this.register,
          tgl,
          this.keluhan_utama,
          this.riwayat_penyakit,
          this.pemeriksaan_fisik,
          this.pemeriksaan_penunjang,
          this.diagnosis,
          this.terapi,
          this.dpjp["id"],
          // this.dokter_id,
          this.sess_login["id"],
          this.sess_login["unit_id"]
        );
        dt.then(dt => {
          this.saving = false;
          // appModule.setLoading(false);

          if (dt["status"] != 1) {
            // appModule.sendErrorAlert(dt["err"]);
          } else {
            this.$emit("respSpri", dt["data"]);
            // this.getSpri()

            // console.log(dt);
            this.modalTtd = true;
            storeSpri.act_spri_on_reg(this.register);
            appModule.NoticeDelay("Berhasil Ubah SPRI");

            this.close();
          }
        });
        // this.dialog = false;
        // console.log('edit')
      } else {
        // console.log('simpan')
        const dt = DataSpri.saveDataSpri(
          this.register,
          tgl,
          this.keluhan_utama,
          this.riwayat_penyakit,
          this.pemeriksaan_fisik,
          this.pemeriksaan_penunjang,
          this.diagnosis,
          this.terapi,
          this.dpjp["id"],
          // this.dokter_id,
          this.sess_login["id"],
          this.sess_login["unit_id"]
        );
        dt.then(dt => {
          this.saving = false;
          // appModule.setLoading(false);

          if (dt["status"] != 1) {
            // appModule.sendErrorAlert(dt["err"]);
          } else {
            this.$emit("respSpri", dt["data"]);
            // this.getSpri()

            // console.log(dt);

            this.modalTtd = true;
            storeSpri.act_spri_on_reg(this.register);
            appModule.NoticeDelay("Berhasil Simpan SPRI");

            this.close();
          }
        });
        // this.dialog = false;
      }
    }
  }
  // @Watch('err')
  // change(value: object, oldValue: object) {
  //     // this.dtDokter = value
  //     // this.listDokter = this.listDokterUnit
  //     this.err=value
  //     // console.log(value)

  //     // this.changeDokter()
  // }
  close() {
    this.expandInput = false;
    this.$emit("close", this.expandInput);
    this.clearInput();
  }

  clearInput() {
    this.keluhan_utama = null;
    this.riwayat_penyakit = null;
    this.pemeriksaan_fisik = null;
    this.pemeriksaan_penunjang = null;
    this.diagnosis = null;
    this.terapi = null;

    this.tanggal = new Date();
  }
}
